module.exports = __webpack_public_path__ + "img/22800.da8816f7.jpg";